import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ClosingCTASection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('memorial-language') || 'ar';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'ar';
      setCurrentLanguage(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  const closingContent = {
    ar: {
      statement: "في الذكرى الأولى للتحرير، نلتقي لنحفظ المعنى، ونكرّم التضحيات، ونستعيد ما جمع السوريين في تلك اللحظة. وجودكم يمنح هذا اليوم روحه وقيمته.",
      cta: "التسجيل لحضور الفعالية"
    },
    en: {
      statement: "On the first anniversary of liberation, we meet to preserve the meaning, honor the sacrifices, and reclaim what brought Syrians together in that moment. Your presence gives this day its spirit and value.",
      cta: "Register to Attend the Event"
    },
    tr: {
      statement: "Kurtuluşun ilk yıldönümünde, anlamı korumak, fedakarlıkları onurlandırmak ve Suriyelileri o anda bir araya getiren şeyi geri kazanmak için buluşuyoruz. Varlığınız bu güne ruhunu ve değerini verir.",
      cta: "Etkinliğe Katılmak İçin Kayıt Olun"
    }
  };

  const scrollToEngagement = () => {
    const element = document.getElementById('get-involved');
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const content = closingContent?.[currentLanguage];

  return (
    <section id="closing-cta" className="py-16 lg:py-24 bg-gradient-to-b from-background to-surface">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-success/10 border border-primary/20 rounded-lg p-8 md:p-12">
            <div className="mb-8">
              <Icon name="Heart" size={48} className="text-primary mx-auto mb-4" />
            </div>
            <p className="font-body text-lg md:text-xl text-text-primary leading-relaxed mb-8 max-w-3xl mx-auto">
              {content?.statement}
            </p>
            <Button
              variant="default"
              size="lg"
              onClick={scrollToEngagement}
              iconName="Calendar"
              iconPosition="left"
              className="w-full sm:w-auto"
            >
              {content?.cta}
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClosingCTASection;
